import { defineStore } from 'pinia';
import router from '@/router';
import stores from '🔗/stores';

const useShareStore = defineStore('share', {
    state: () => ({
    }),
    actions: {
        invite() {
            const t = stores.locale().t();

            stores.modals().open('share', {
                quietClose: true,
                data: {
                    url: stores.messengers().base + `ref_${stores.user()?.profile?.id}`,
                    message: t('modals.share.invite.message'),
                    description: t('modals.share.invite.description'),
                    title: t('modals.share.invite.title'),
                    copied: t('modals.share.invite.copied')
                }
            });
        },
        artist({ code, name }) {
            const t = stores.locale().t();

            stores.modals().open('share', {
                quietClose: true,
                data: {
                    url: stores.messengers().base + `a_${code}`,
                    message: t('modals.share.artist.message', { name }),
                    description: t('modals.share.artist.description'),
                    title: name, // t('modals.share.artist.title'),
                    copied: t('modals.share.artist.copied')
                }
            });
        },
        release({ id, title }) {
            const t = stores.locale().t();

            stores.modals().open('share', {
                quietClose: true,
                data: {
                    url: stores.messengers().base + `r_${id}`,
                    message: t('modals.share.release.message', { name: title }),
                    description: t('modals.share.release.description'),
                    title, // t('modals.share.release.title'),
                    copied: t('modals.share.release.copied')
                }
            });
        },
        playlist({ id, title }) {
            const t = stores.locale().t();

            stores.modals().open('share', {
                quietClose: true,
                data: {
                    url: stores.messengers().base + `p_${id}`,
                    message: t('modals.share.playlist.message', { name: stores.locale().title(title) }),
                    description: t('modals.share.playlist.description'),
                    title, // t('modals.share.playlist.title'),
                    copied: t('modals.share.playlist.copied')
                }
            });
        },
        track({ id, title }, options) {
            const t = stores.locale().t();
            let url = stores.messengers().base + `t_${id}`;


            if (options?.type === 'release') {
                if (options.release?.id) {
                    url += `__r_${options.release.id}`;
                }
            }

            stores.modals().open('share', {
                quietClose: true,
                data: {
                    url,
                    message: t('modals.share.track.message', { name: title }),
                    description: t('modals.share.track.description'),
                    title, // t('modals.share.track.title'),
                    copied: t('modals.share.track.copied')
                }
            });
        },
        dict({ code, title }, type) {
            const t = stores.locale().t();

            stores.modals().open('share', {
                quietClose: true,
                data: {
                    url: stores.messengers().base + `${type.code[0].toLowerCase()}_${code}`,
                    message: t(`modals.share.${type.code}.message`, { name: stores.locale().title(title) }),
                    description: t(`modals.share.${type.code}.description`),
                    title: stores.locale().title(title), // t('modals.share.${type.code}.title'),
                    copied: t(`modals.share.${type.code}.copied`)
                }
            });
        }
    }
});

export default useShareStore;
